import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { Section, Eyebrow } from '../ui/Section';
import { Button } from '../ui/Button';
import { BrandCurve } from '../ui/BrandCurve';
import { CONTACT } from '../../lib/constants';
export function FinalCTA() {
  return <Section className="relative overflow-hidden bg-navy" ariaLabel="Get an independent view of your IT" data-id="element-192">
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(90% 90% at 50% 0%, rgba(0,168,232,0.16), transparent 60%)'
    }} aria-hidden data-id="element-193" />
      <BrandCurve className="-left-40 top-1/2 h-[500px] w-[500px] -translate-y-1/2 opacity-70" data-id="element-194" />
      <BrandCurve className="-right-40 top-1/2 h-[500px] w-[500px] -translate-y-1/2 opacity-70" data-id="element-195" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-196">
        <div className="flex justify-center" data-id="element-197">
          <Eyebrow onDark color="var(--ct-light-blue)" data-id="element-198">
            Clarity before commitment
          </Eyebrow>
        </div>
        <h2 className="mt-4 font-display text-[30px] font-black leading-tight text-white md:text-[46px]" data-id="element-199">
          Get an independent view of your IT.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-white/75 md:text-[19px]" data-id="element-200">
          Understand the environment, identify material risks and leave with
          practical next steps — whether or not you decide to change providers.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-201">
          <Button as="a" href="#it-review" variant="primary" data-id="element-202">
            Book an independent IT Review
            <ArrowRight className="h-4 w-4" aria-hidden data-id="element-203" />
          </Button>
          <Button as="a" href={CONTACT.phoneHref} variant="ghost" data-id="element-204">
            <Phone className="h-4 w-4" aria-hidden data-id="element-205" />
            Call {CONTACT.phone}
          </Button>
        </div>
        <p className="mt-5 text-[14px] text-white/60" data-id="element-206">
          Or email{' '}
          <a href={CONTACT.emailHref} className="font-semibold text-ct-light hover:underline" data-id="element-207">
            {CONTACT.email}
          </a>
        </p>
      </div>
    </Section>;
}